import {
  useFormCategoriesSearchListLazyQuery,
  useTasksSearchListLazyQuery,
} from 'graphql-common';
import { getFormCategoriesLoadOptions as getFormCategoriesLoadOptionsFn } from 'utils/fetch/searchLists/formCategoriesSearchList';
import { getTasksLoadOptions as getTasksLoadOptionsFn } from 'utils/fetch/searchLists/tasksSearchList';
import { GetLoadOptions } from '@lib/components/Select/types';

interface Props {
  id: string;
}

export default function useSearchListQueries(props: Props) {
  const { id } = props;

  // Form category
  const [fetchFormCategoriesLazyQuery] = useFormCategoriesSearchListLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const getFormCategoriesLoadOptions: GetLoadOptions = () =>
    getFormCategoriesLoadOptionsFn(fetchFormCategoriesLazyQuery);

  const [fetchTasksLazyQuery] = useTasksSearchListLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const getTasksLoadOptions: GetLoadOptions = () =>
    getTasksLoadOptionsFn({
      fetchLazyQuery: fetchTasksLazyQuery,
      scope: {
        custom: {
          linkedToFormTemplateGrouped: { templateId: id },
        },
      },
      selectedSiteIds: [],
    });

  return {
    getFormCategoriesLoadOptions,
    getTasksLoadOptions,
  };
}
